import { API_URL, createRequestActionTypes } from "../../../actions/index";

export const READ_MANY_DOCUMENTS_URL = `${API_URL}/api/v1/documents`;
export const READ_ONE_DOCUMENT_URL = `${API_URL}/api/v1/document`;
export const DOWNLOAD_DOCUMENT_URL = `${API_URL}/api/v1/document`;

export const GET_DOCUMENTS_ERROR = "Error reading documents";
export const GET_DOCUMENT_ERROR = "Error reading document";
export const DOWNLOAD_DOCUMENT_ERROR = "Error downloading document";

export const documentsActionTypes = {
  getDocuments: createRequestActionTypes("GET_DOCUMENTS"),
  getDocument: createRequestActionTypes("GET_DOCUMENT"),
};

export const DOCUMENTS_TABLE_HEADERS = [
  { heading: "Title", width: "30%", class: "" },
  { heading: "Type", width: "15%", class: "" },
  { heading: "Campaign", width: "25%", class: "" },
  { heading: "Created", width: "20%", class: "" },
  { heading: "Actions", width: "10%", class: "text-center" },
];
